import React, { useEffect, useState } from 'react';
import * as Unicons from '@iconscout/react-unicons';
import AdminLayout from '../../components/layout/admin';
import Breadcrumbs from '../../components/elements/Breadcrumbs';
import { useQuery } from '@tanstack/react-query';
import { Stack, Box, SegmentedControl, Space } from '@mantine/core';
import { getInventoryReward } from '../../services/user-redeem';
import LoaderVoucher from './LoaderVoucher';
import FailedIllustration from '../../components/fragments/IllustrationState/FailedIllustration';
import { ERROR_STATE } from '../../constants/defaultValues/errorState';
import AvailableVoucherList from './fragments/AvailableVoucherList';
import WaitingApprovalList from './fragments/WaitingApprovalList';
import ApprovedVoucherList from './fragments/ApprovedVoucherList';
import RejectVoucherList from './fragments/RejectVoucherList';

const RnbRedeem = (props) => {
  const [selectedStatus, setSelectedStatus] = useState('av-voucher');
  const [tabStatus, setTabStatus] = useState([]);

  const fetchedRnbRedeem = useQuery({
    queryKey: ['getRnbRedeemVoucherUser'],
    queryFn: () =>
      getInventoryReward({
        search: '',
        page: 1,
        size: 10
      })
  });

  const {
    data: dataRnbRedeem,
    isLoading,
    isFetching,
    isError
  } = fetchedRnbRedeem;

  useEffect(() => {
    if (dataRnbRedeem?.data?.data) {
      setTabStatus([
        {
          value: 'av-voucher',
          label: `Available Voucher (${dataRnbRedeem?.data?.dataKosong.length})`
        },
        {
          value: 'waiting-voucher',
          label: `Waiting Approval (${dataRnbRedeem?.data?.dataActive.length})`
        },
        {
          value: 'app-voucher',
          label: `Approved Voucher (${dataRnbRedeem?.data?.dataApproved.length})`
        },
        {
          value: 'reject-voucher',
          label: `Rejected Voucher (${dataRnbRedeem?.data?.dataRejected.length})`
        }
      ]);
    } else {
      setTabStatus([
        {
          value: 'av-voucher',
          label: 'Available Voucher (0)'
        },
        {
          value: 'waiting-voucher',
          label: 'Waiting Approval (0)'
        },
        {
          value: 'app-voucher',
          label: 'Approved Voucher (0)'
        },
        {
          value: 'reject-voucher',
          label: 'Rejected Voucher (0)'
        }
      ]);
    }
  }, [dataRnbRedeem?.data?.data]);

  return (
    <AdminLayout>
      <Breadcrumbs
        pageTitle="Reward and Gamification"
        itemList={[
          {
            title: 'Reward and Gamification',
            href: '#',
            icon: <Unicons.UilGift size={16} />
          },
          {
            title: 'List Voucher',
            href: 'rnb/redeem'
          }
        ]}
      />
      {tabStatus.length > 0 && (
        <Stack gap={0} my={16}>
          <Box component="div">
            <SegmentedControl
              value={selectedStatus}
              onChange={(value) => setSelectedStatus(value)}
              data={tabStatus}
              radius={'lg'}
            />
          </Box>
        </Stack>
      )}

      {isLoading && <LoaderVoucher />}

      {isError && (
        <FailedIllustration
          title={ERROR_STATE.error[0]}
          description={ERROR_STATE.resolution[0]}
          w={200}
        />
      )}

      {!isLoading && !isError && dataRnbRedeem?.data?.data && (
        <>
          <AvailableVoucherList
            data={fetchedRnbRedeem?.data?.data?.dataKosong}
            activeTab={selectedStatus}
          />
          <WaitingApprovalList
            data={fetchedRnbRedeem?.data?.data?.dataActive}
            activeTab={selectedStatus}
          />
          <ApprovedVoucherList
            data={fetchedRnbRedeem?.data?.data?.dataApproved}
            activeTab={selectedStatus}
          />
          <RejectVoucherList
            data={fetchedRnbRedeem?.data?.data?.dataRejected}
            activeTab={selectedStatus}
          />
          <Space h={32} />
        </>
      )}
    </AdminLayout>
  );
};

export default RnbRedeem;
